import React from "react";

import { useDeviceTableActions } from "./DeviceTableActionsContext";
import DeviceVersionStatusChip from "./DeviceVersionStatusChip";
import type { Device } from "../model";

interface VersionColumnProps {
  device: Device;
}

export default function VersionColumn({ device }: VersionColumnProps) {
  const { openUpgradeForDevice, openAgentUpgradeForDevice } =
    useDeviceTableActions();

  const handleOpenUpgrade = () => {
    if (device.is_agent) {
      openAgentUpgradeForDevice(device);
      return;
    }

    openUpgradeForDevice(device);
  };

  return (
    <DeviceVersionStatusChip
      device={device}
      onUpgradeClick={handleOpenUpgrade}
      pendingChipDataTestId="version-column-pending-chip"
      updateAvailableChipDataTestId="version-column-update-available-chip"
      upToDateChipDataTestId="version-column-up-to-date-chip"
    />
  );
}
